import { useRef, useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Camera, Loader2 } from "lucide-react";

const isPhone = () => typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;

export const CameraCapture = ({ pending, autoImport, onSnap }) => {
  const inputRef = useRef(null);
  const [show, setShow] = useState(isPhone);

  useEffect(() => {
    const mq = window.matchMedia("(pointer: coarse)");
    const fn = (e) => setShow(e.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);

  if (!show) return null;

  return (
    <div data-testid="pic-camera-capture" style={{ marginBottom: 16 }}>
      <Button onClick={() => inputRef.current?.click()} data-testid="pic-take-photo-btn"
        style={{ width: "100%", height: 56, fontSize: 17, fontWeight: 600, borderRadius: 14 }}>
        <Camera size={22} style={{ marginRight: 10 }} /> Take photo
      </Button>
      <input ref={inputRef} type="file" accept="image/*" capture="environment" hidden data-testid="pic-camera-input"
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onSnap(f); }} />
      <p style={{ textAlign: "center", color: "#64748b", fontSize: 13, marginTop: 8 }} data-testid="pic-camera-status">
        {pending > 0
          ? <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><Loader2 size={14} className="animate-spin" /> Reading {pending} card{pending > 1 ? "s" : ""} — keep snapping</span>
          : autoImport ? "Each card is read and sent to your CRM as you snap it" : "Each card is read as you snap it — review below"}
      </p>
    </div>
  );
};
